import { __awaiter, __generator } from "tslib";
import Promise from 'bluebird';
import request from 'superagent';
Promise.promisifyAll(request);
var requestFactory = function (options) {
    if (options === void 0) { options = {}; }
    var method = options.method || 'post';
    var url = options.url;
    var json = JSON.stringify(options.data);
    var requestInstance = request[method](url)
        .set('Accept', 'application/json')
        .set('Content-Type', 'application/json');
    if (options.token) {
        requestInstance.set('X-Canvas-Auth', options.token);
    }
    if (options.userId) {
        requestInstance.set('X-Marvel-User', options.userId);
    }
    if (options.accessToken) {
        requestInstance.set('Authorization', "Bearer ".concat(options.accessToken));
    }
    return requestInstance.send(json);
};
export var tokenProvider = {
    accessToken: '',
    baseUri: 'https://marvelapp.com',
    newCanvas: function (projectId) {
        return requestFactory({
            accessToken: tokenProvider.accessToken,
            url: "".concat(tokenProvider.baseUri, "/api/token/canvas/").concat(projectId, "/"),
            fingerprint: ['Token provider', 'new canvas'],
        }).endAsync();
    },
    newComponent: function () {
        return requestFactory({
            accessToken: tokenProvider.accessToken,
            url: "".concat(tokenProvider.baseUri, "/api/token/canvas/library/component/"),
            fingerprint: ['Token provider', 'new component'],
        }).endAsync();
    },
    newCanvasForContent: function (projectId, contentId) {
        return requestFactory({
            accessToken: tokenProvider.accessToken,
            url: "".concat(tokenProvider.baseUri, "/api/canvas/set-canvas-id/"),
            data: {
                project_id: projectId,
                content_id: contentId,
            },
            fingerprint: ['Token provider', 'new canvas for content'],
        }).endAsync();
    },
    getLibraryAuth: function () {
        return requestFactory({
            accessToken: tokenProvider.accessToken,
            url: "".concat(tokenProvider.baseUri, "/api/token/canvas/library/"),
            fingerprint: ['Token provider', 'get library auth'],
        }).endAsync();
    },
    getAuth: function (id, projectId) {
        var url;
        // TODO: split this out into separate methods to make intent clearer
        // When refactoring, ensure that token refreshing works as expected
        if (projectId) {
            url = "".concat(tokenProvider.baseUri, "/api/token/canvas/").concat(projectId, "/").concat(id, "/");
        }
        else {
            url = "".concat(tokenProvider.baseUri, "/api/token/canvas/library/component/").concat(id, "/");
        }
        return requestFactory({
            accessToken: tokenProvider.accessToken,
            url: url,
            fingerprint: ['Token provider', 'get auth'],
        }).endAsync();
    },
};
export var images = {
    baseUri: 'https://marvelapp.com',
    csrfToken: null,
    csrfTokenHeader: 'X-CSRFToken',
    _backoffMultiplier: 1000,
    upload: function (file, uuid) {
        return __awaiter(this, void 0, void 0, function () {
            function reqFactory(csrfToken, csrfTokenHeader) {
                tries += 1;
                var req = request.post(url).attach('file', file);
                if (csrfToken) {
                    req.set(csrfTokenHeader, csrfToken);
                }
                return req
                    .endAsync()
                    .then(function (resp) {
                    return resp.body;
                })
                    .catch(function (err) {
                    if (tries < maxTries) {
                        var delay = Math.pow(tries, 2) * backoffMultiplier; // exponential backoff
                        return Promise.delay(delay).then(function () {
                            return reqFactory(csrfToken, csrfTokenHeader);
                        });
                    }
                    return Promise.reject(new Error('Upload failed', err));
                });
            }
            var url, maxTries, tries, backoffMultiplier;
            return __generator(this, function (_a) {
                url = "".concat(this.baseUri, "/api/content/canvas/upload/");
                if (uuid) {
                    url += "".concat(uuid, "/");
                }
                maxTries = 5;
                tries = 0;
                backoffMultiplier = this._backoffMultiplier;
                return [2 /*return*/, reqFactory(this.csrfToken, this.csrfTokenHeader)];
            });
        });
    },
    urlIsMarvelURL: function (url) {
        return (url.search(/https:\/\/marvelapp-(dev|live)\.storage\.googleapis\.com\/canvas\//) !== -1 ||
            url.search(/https:\/\/marvel-(dev|live)\.freetls.fastly.net\/canvas\//) !== -1);
    },
    uploadFromURL: function (imageURL, uuid, imageParams) {
        if (imageParams === void 0) { imageParams = {}; }
        return __awaiter(this, void 0, void 0, function () {
            function reqFactory(csrfToken, csrfTokenHeader) {
                tries += 1;
                var req = request.post(url).send(body);
                if (csrfToken) {
                    req.set(csrfTokenHeader, csrfToken);
                }
                return req
                    .endAsync()
                    .then(function (resp) {
                    return resp.body;
                })
                    .catch(function (err) {
                    if (tries < maxTries) {
                        var delay = Math.pow(tries, 2) * backoffMultiplier; // exponential backoff
                        return Promise.delay(delay).then(function () {
                            return reqFactory(csrfToken, csrfTokenHeader);
                        });
                    }
                    return Promise.reject(new Error('Upload failed', err));
                });
            }
            var url, body, maxTries, tries, backoffMultiplier;
            return __generator(this, function (_a) {
                if (this.urlIsMarvelURL(imageURL)) {
                    return [2 /*return*/, Promise.resolve({ url: imageURL })];
                }
                url = "".concat(this.baseUri, "/api/content/canvas/upload-from-url/");
                body = {
                    url: imageURL,
                    imageParams: imageParams,
                };
                if (uuid) {
                    body.uuid = uuid;
                }
                maxTries = 5;
                tries = 0;
                backoffMultiplier = this._backoffMultiplier;
                return [2 /*return*/, reqFactory(this.csrfToken, this.csrfTokenHeader)];
            });
        });
    },
};
export var easel = {
    baseUri: 'https://easel.marvelapp.com',
    versionPathString: 'v2',
    create: function (_a) {
        var data = _a.data, token = _a.token, userId = _a.userId;
        var url = "".concat(easel.baseUri, "/").concat(easel.versionPathString, "/canvas/");
        return requestFactory({
            data: data,
            fingerprint: ['Easel', 'create'],
            token: token,
            url: url,
            userId: userId,
        })
            .endAsync()
            .then(function (response) {
            // HACK: Easel v2 returns different response structures for
            // create vs save requests so this makes them consistent
            var responseBody = response.body;
            response.body = responseBody.canvas;
            return response;
        });
    },
    save: function (_a) {
        var token = _a.token, id = _a.id, data = _a.data, userId = _a.userId;
        var url = "".concat(easel.baseUri, "/").concat(easel.versionPathString, "/canvas/").concat(id, "/");
        return fetch({
            data: data,
            fingerprint: ['Easel', 'save'],
            method: 'put',
            token: token,
            url: url,
            userId: userId,
        });
    },
    fetch: function (_a) {
        var token = _a.token, id = _a.id, userId = _a.userId;
        var url = "".concat(easel.baseUri, "/").concat(easel.versionPathString, "/canvas/").concat(id, "/");
        return fetch({
            url: url,
            token: token,
            fingerprint: ['Easel', 'fetch'],
            userId: userId,
        });
    },
    fetchCode: function (_a) {
        var token = _a.token, id = _a.id, type = _a.type, userId = _a.userId, colorMode = _a.colorMode;
        var url = "".concat(easel.baseUri, "/").concat(easel.versionPathString, "/canvas/").concat(id, "/code-snippet/").concat(type, "/");
        if (type === 'css') {
            url = "".concat(url, "?colorMode=").concat(colorMode);
        }
        return fetch({
            url: url,
            token: token,
            fingerprint: ['Easel', 'fetch code'],
            userId: userId,
        });
    },
    fetchLibrary: function (_a) {
        var id = _a.id, token = _a.token, userId = _a.userId;
        var url = "".concat(easel.baseUri, "/").concat(easel.versionPathString, "/libraries/").concat(id, "/");
        return fetch({
            url: url,
            token: token,
            userId: userId,
            fingerprint: ['Easel', 'fetch library'],
        });
    },
    deleteComponents: function (_a) {
        var componentIds = _a.componentIds, libraryId = _a.libraryId, token = _a.token, userId = _a.userId;
        var url = "".concat(easel.baseUri, "/").concat(easel.versionPathString, "/libraries/").concat(libraryId, "/delete/");
        return fetch({
            data: componentIds,
            fingerprint: ['Easel', 'delete library components'],
            method: 'post',
            token: token,
            url: url,
            userId: userId,
        });
    },
    delete: function (_a) {
        var token = _a.token, id = _a.id, userId = _a.userId;
        var url = "".concat(easel.baseUri, "/").concat(easel.versionPathString, "/canvas/").concat(id, "/");
        return fetch({
            token: token,
            url: url,
            method: 'delete',
            fingerprint: ['Easel', 'Delete'],
            userId: userId,
        });
    },
};
var tokenExpiryBufferMs = 12e4; // 2 minutes in ms
export function withActiveToken(fn, token, getToken) {
    return __awaiter(this, void 0, void 0, function () {
        var now, currentToken, needsRefresh, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    now = new Date(Date.now());
                    currentToken = token;
                    needsRefresh = currentToken === undefined || token.expires <= now + tokenExpiryBufferMs;
                    if (!needsRefresh) return [3 /*break*/, 2];
                    return [4 /*yield*/, getToken()];
                case 1:
                    currentToken = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 7]);
                    return [4 /*yield*/, fn(currentToken)];
                case 3: return [2 /*return*/, _a.sent()];
                case 4:
                    err_1 = _a.sent();
                    if (!(!needsRefresh && err_1.status === 401)) return [3 /*break*/, 6];
                    return [4 /*yield*/, getToken()];
                case 5:
                    currentToken = _a.sent();
                    return [2 /*return*/, fn(currentToken)];
                case 6: throw err_1;
                case 7: return [2 /*return*/];
            }
        });
    });
}
// Generic fetch used in exported fetch methods
function fetch(_a) {
    var _b = _a.method, method = _b === void 0 ? 'get' : _b, url = _a.url, token = _a.token, data = _a.data, fingerprint = _a.fingerprint, userId = _a.userId;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_c) {
            return [2 /*return*/, requestFactory({
                    token: token,
                    userId: userId,
                    url: url,
                    method: method,
                    data: data,
                    fingerprint: fingerprint,
                }).endAsync()];
        });
    });
}
